import { dateHeader, formatCellDate } from './timeModeCell';

export const makeInventoryValidationColumn = () => {
  const col = [
    {
      header: 'Device ID',
      sortable: false,
      enableColumnFilter: false,
      size: 150,
      cell: ({ row }) => <span>{row.original.deviceId}</span>,
    },
    {
      header: 'Type',
      accessorKey: 'type',
      sortable: false,
      enableColumnFilter: false,
      size: 150,
      cell: ({ row }) => <span>{row.original.type.type}</span>,
    },
    {
      header: 'Type name',
      sortable: false,
      enableColumnFilter: false,
      size: 150,
      cell: ({ row }) => <span>{row.original.type.name}</span>,
    },
    {
      header: 'Manufacturer',
      accessorKey: 'manufacturer',
      sortable: false,
      enableColumnFilter: false,
      size: 150,
      cell: ({ row }) => <span>{row.original.type.manufacturer}</span>,
    },
    {
      header: dateHeader('Manufacture Date time'),
      accessorKey: 'manufactureDateTime',
      size: 170,
      cell: ({ row, table }) => formatCellDate(table, row.original.manufactureDateTime),
    },
    {
      header: dateHeader('Created'),
      accessorKey: 'createdDateTime',
      size: 110,
      cell: ({ row, table }) => formatCellDate(table, row.original.createdDateTime),
    },
  ] as Array<any>;

  return col;
};
